module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dear-Reader.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("Dear Reader,")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("The idea for this story began with a Regency cartoon showing a frantic Norfolk turkey escaping from its Christmas doom in Leadenhall Market. I wondered what became of it and found the answer when my hero rescued the ungrateful bird from a snowdrift. From there the story just grew, set in a snowy Norfolk landscape not far from where I live.")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("We don’t often get heavy snow, let alone a white Christmas, in this part of the world, so the idea of my lovers snowed in together was a Christmas fantasy for me, as well as for them.")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("I hope Giles and Julia’s story gives you a warm glow this winter, wherever you are.")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("A happy Christmas,")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Louise Allen")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ec5b0ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dear_Reader.vue
// module id = 81
// module chunks = 0